<template>
  <span>
    <v-fab-transition v-if="wizards.length > 0">
      <v-menu
        top
        left
        :nudge-width="210"
        offset-x
        content-class="nx-wizard-select__wizards-list"
      >
          <v-btn
            :style="wizardButtonStyle"
            :color="inline ? '' : 'accent'"
            fab
            class="ma-0 v-btn v-btn--icon theme--light"
            :class="{'v-btn--disabled': inline}"
            :fixed="!inline"
            :bottom="!inline"
            :right="!inline"
            v-show="wizards || inline"
            slot="activator"
          >
          <v-icon v-text="inline ? 'add_circle' : 'add'">add</v-icon>
          </v-btn>
        <v-list dense>
          <v-list-tile v-for="wizard in wizards.slice(0, 9)" :key="wizard.name"
                       @click="openWizard(wizard.name)">
            <v-list-tile-avatar v-if="wizard.icon">
              <v-icon v-html="wizard.icon"></v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>{{ $t('message.wizard.' + wizard.name) }}</v-list-tile-title>
          </v-list-tile>

          <v-menu v-if="wizards.length > 9"
                  full-width
                  offset-x
                  open-on-hover
                  left
                  bottom
                  content-class="nx-wizard-select__wizards-list"
          >
            <v-list-tile slot="activator">
              <v-list-tile-avatar>
                <v-icon>keyboard_arrow_left</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ $t('message.common.viewMore') }}</v-list-tile-title>
            </v-list-tile>
            <v-list dense>
              <v-list-tile v-for="wizard in wizards.slice(9, wizards.length)"
                           :key="wizard.name"
                           @click="openWizard(wizard.name)">
                <v-list-tile-avatar v-if="wizard.icon">
                  <v-icon v-html="wizard.icon"></v-icon>
                </v-list-tile-avatar>
                <v-list-tile-title>{{ $t('message.wizard.' + wizard.name) }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-list>
      </v-menu>
    </v-fab-transition>
    <nx-entity-wizard
      :active="showWizard"
      :entity="entityWizard"
      :custom-config="wizardFieldsConfig"
      :merge-fields-config="mergeWizardFieldsConfig"
      :default-value="defaultValue"
      enable-create-and-continue
      @dismiss="closeWizard"
      @entityCreated="entityCreated">
    </nx-entity-wizard>
  </span>
</template>

<script>
import NxEntityWizard from '@/modules/entity/wizard/Wizard';

export default {
  name: 'nx-select-entity-wizard',
  components: {
    NxEntityWizard,
  },
  data() {
    return {
      entityWizard: '',
      showWizard: false,
    };
  },
  props: {
    wizards: Array,
    inline: Boolean,
    wizardFieldsConfig: {
      type: Array,
    },
    mergeWizardFieldsConfig: {
      type: Array,
      default: () => (['']),
    },
    defaultValue: {
      type: Object,
    },
  },
  computed: {
    wizardButtonStyle() {
      if (this.inline) {
        return {
          width: '24px',
          height: '24px',
        };
      }
      return {
        'margin-right': this.$store.state.app.bag ? '360px' : '0',
      };
    },
  },
  methods: {
    openWizard(entityWizard) {
      this.entityWizard = entityWizard;
      this.$nextTick(() => {
        this.showWizard = true;
      });
    },
    closeWizard() {
      this.entityWizard = '';
      this.showWizard = false;
    },
    entityCreated(entity) {
      console.log('entity created', entity);
      if (entity && entity.route && entity.navigateToEntityEditor) {
        this.$router.push(entity.route);
      }
    },
  },
};
</script>

<style lang="stylus">
.nx-wizard-select__wizards-list {
  max-height: calc(100vh - 100px);
}
</style>
